import { render, staticRenderFns } from "./NormalOrderSummary.vue?vue&type=template&id=4480a635"
import script from "./NormalOrderSummary.vue?vue&type=script&lang=js"
export * from "./NormalOrderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports